<!--召回弹层-->
<template>
  <RecalledCustomerFunc
    default-cls="dlrLayer"
    display-cls="slideMiddle_in"
    hide-cls="slideMiddle_out"
    #default="{ adData, goAct, close, statAction, extend }"
  >
    <div
      class="dlrLayer-middle maskbox-Recall"
      v-stat:show="{ action: statAction.showName, extend }"
    >
      <div class="dlrRecall">
        <div v-if="adData.activityType === 3" class="dlrRecall-txt">
          <p class="dlrRecall-tit">{{ adData.title }}</p>
          <p>{{ adData.subTitle }}</p>
        </div>
        <!---以下为另一种样式-->
        <div
          v-if="adData.activityType === 1 || adData.activityType === 2"
          class="dlrRecall-txt"
        >
          {{ adData.title }}
        </div>
        <div class="dlrRecall-pic">
          <img v-if="adData.icon" :src="adData.icon" />
        </div>
        <a
          href="javascript:;"
          class="dlrRecall-btn"
          @click="goAct"
          v-stat:click="{ action: statAction.goActActionName, extend }"
          >{{ adData.buttonText }}</a
        >
        <a
          href="javascript:;"
          class="dlrRecall-close"
          v-stat:click="{ action: statAction.closeActionName, extend }"
          @click="close"
        ></a>
      </div>
    </div>
    <div
      style="background-color: #999 !important"
      class="dlrLayer-mask"
      v-stat:click="{ action: statAction.closeActionName, extend }"
      @click="close"
    ></div>
  </RecalledCustomerFunc>
</template>
<script>
import RecalledCustomerFunc from './RecalledCustomerFunc';
export default {
  components: {
    RecalledCustomerFunc
  }
};
</script>
<style lang="scss">
  .dlrRecall{
	position: relative;
	width:ptrd(560);
	height: ptrd(750);
	margin-top:ptrd(-136);
	background:url($img + 'recallbg.png') no-repeat;
	background-size: 100% auto;
	text-align: center;
	margin: ptrd(-136) auto 0;
	.dlrRecall-txt{
		padding: ptrd(210) ptrd(70) 0;
		font-size: ptrd(32);
		line-height: ptrd(48);
		color: #ff6600;
		text-align: center;
		@include fn-ellipsis(2);
	}
	.dlrRecall-tit{
		color: #111E36;
	}
	.dlrRecall-pic{
		display: inline-block;
		//padding-top: ptrd(24);
		width: ptrd(336);
		height: ptrd(252);
		overflow: hidden;
		img{
			vertical-align: top;
			width: 100%;
			height: 100%;
		}
	}
	.dlrRecall-btn{
		position: absolute;
		bottom: ptrd(40);
		left: 50%;
		transform: translateX(-50%);
		width: ptrd(440);
		height: ptrd(88);
		line-height: ptrd(88);
		font-size: ptrd(32);
		color: #FF6600;
	}
	.dlrRecall-close {
		position: absolute;
        display: block;
        width: ptrd(76);
        height: ptrd(76);
        position: absolute;
        bottom: ptrd(-136);
        left: 50%;
        margin-left: ptrd(-38);
        background:url(https://s.autoimg.cn/dealer/m/vr/img_new/close-icon.png) no-repeat center center;
        background-size: 100% 100%;
    }
}
.Recall.maskbox{
	.maskbox-bg{
		background: #999;
	}
}

</style>
